import React from 'react';
import clsx from 'clsx';

import { Image } from '../Image';

type AvatarProps = {
  avatarUrl?: string;
  userName?: string;
  className?: string;
};

export const Avatar: React.FC<AvatarProps> = ({
  avatarUrl,
  userName = '',
  className = 'w-10 h-10',
}) => {
  const getInitials = (email: string) => {
    const namePart = email.split('@')[0];
    const nameParts = namePart.split('.');

    const initials = nameParts
      .map(word => word.charAt(0).toUpperCase())
      .join('');

    return initials;
  };

  return (
    <div className={clsx(className, 'relative')}>
      {avatarUrl ? (
        <Image
          imageUrl={avatarUrl}
          title={userName}
          imageClassName="rounded-full"
          className="w-full h-full object-cover"
        />
      ) : (
        <div
          className={clsx(
            className,
            'flex items-center justify-center rounded-full bg-middleGray font-semibold text-medium'
          )}
        >
          {getInitials(userName)}
        </div>
      )}
    </div>
  );
};
